import type { IntermediaryPage } from 'korint-sdk/react';

// Placed right after the reports it lists; the layout hides it until the feature flag is on.
const withCommissions = (
  pages: ReadonlyArray<IntermediaryPage>,
): ReadonlyArray<IntermediaryPage> => {
  if (pages.some(page => page.type === 'commissions')) {
    return pages;
  }

  const reportsIndex = pages.findIndex(page => page.type === 'reports');
  const insertAt = reportsIndex === -1 ? pages.length : reportsIndex + 1;

  return [...pages.slice(0, insertAt), { type: 'commissions' }, ...pages.slice(insertAt)];
};

// No tenant config: shown behind feat_claims_management, to LIST_CLAIMS_MANAGEMENT holders only.
const withClaims = (pages: ReadonlyArray<IntermediaryPage>): ReadonlyArray<IntermediaryPage> => {
  if (pages.some(page => page.type === 'claims')) {
    return pages;
  }

  const myBrokerageFirmIndex = pages.findIndex(page => page.type === 'my-brokerage-firm');
  const insertAt = myBrokerageFirmIndex === -1 ? pages.length : myBrokerageFirmIndex;

  return [...pages.slice(0, insertAt), { type: 'claims' }, ...pages.slice(insertAt)];
};

export const withImplicitIntermediaryPages = (
  pages: ReadonlyArray<IntermediaryPage>,
): ReadonlyArray<IntermediaryPage> => withClaims(withCommissions(pages));
